import { isWeb } from "tamagui";

import type { StackStyleBase, TextStylePropsBase } from "@tamagui/web";

type ShadowStyle = Pick<StackStyleBase, "boxShadow">;
type TextShadowStyle = Pick<TextStylePropsBase, "textShadow">;

export const shadow = {
  /** Used for plates and card shadows */
  light: {
    boxShadow: "0px 2px 8px rgba(0, 0, 0, 0.05)",
  },
  /** Native renders the same two layers (React Native's `boxShadow` takes a
   *  list). */
  subtle: {
    boxShadow: "0 0 2px #2529190D, 0 0 11px #25291913",
  },
  /** Used for floating controls and dialogues */
  medium: {
    boxShadow: "0px 2px 12px rgba(0, 0, 0, 0.08)",
  },
  /** Used for desktop web dialogues. */
  heavy: {
    boxShadow: "0px 16px 64px rgba(0, 0, 0, 0.12)",
  },
} as const satisfies Record<string, ShadowStyle>;

export type ShadowVariant = keyof typeof shadow;

/** For light text on photos. Native allows one layer. */
export const textShadow = {
  textShadow: isWeb
    ? "0 0 90px rgba(0, 0, 0, 0.62), 0 0 50px rgba(0, 0, 0, 0.52), 0 0 26px rgba(0, 0, 0, 0.4), 0 0 10px rgba(0, 0, 0, 0.3)"
    : "0 0 26px rgba(0, 0, 0, 0.6)",
} as const satisfies TextShadowStyle;
